import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useCallback, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import { getUrlLogin } from "../services/auth/authService";
import { getReturnUrlFromLocalStorage, setReturnUrlFromLocalStorage, tokenHasExpired, } from "../services/localStorage/localStorageService";
function Login(props) {
    const { buttonIcon, returnUrl } = props;
    const { setToken, setUser } = useAuth();
    useEffect(() => {
        if (tokenHasExpired())
            setToken("");
    }, []);
    const login = useCallback(() => {
        setReturnUrlFromLocalStorage(returnUrl || window.location.pathname);
        getUrlLogin().then((data) => {
            //@ts-ignore
            setUser(data.userData);
            //@ts-ignore
            window.location.href = data.loginUrl;
        });
    }, []);
    return tokenHasExpired() ? (buttonIcon(login)) : (_jsx(Redirect, { to: getReturnUrlFromLocalStorage() || "/" }));
}
export default Login;
